export const IDS = {
    //paths
    pcDocumentTypeGrid: 'pcDocumentTypeGrid',

    // tiles states:
    app_policies_documents_dashboard: 'app.policies.documents.dashboard',
    app_policies_documents_approval: 'app.policies.documents.approval',
 
};